'use strict';

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _hypot = require('babel-runtime/core-js/math/hypot');

var _hypot2 = _interopRequireDefault(_hypot);

require('../vendor/greensock');

var _imagesloaded = require('imagesloaded');

var _imagesloaded2 = _interopRequireDefault(_imagesloaded);

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/* eslint-disable */
var containerEl = void 0;

/**
 * demo6.js
 * http://www.codrops.com
 *
 * Licensed under the MIT license.
 * http://www.opensource.org/licenses/mit-license.php
 *
 * Copyright 2019, Codrops
 * http://www.codrops.com
 */
/* global TweenMax, TimelineMax, Expo */
{
  // body element
  var body = document.querySelector('.it-ImageTrail');

  // helper functions
  var MathUtils = {
    // linear interpolation
    lerp: function lerp(a, b, n) {
      return (1 - n) * a + n * b;
    },
    // distance between two points
    distance: function distance(x1, y1, x2, y2) {
      return (0, _hypot2.default)(x2 - x1, y2 - y1);
    }

    // get the mouse position
  };var getMousePos = function getMousePos(ev) {
    var posx = 0;
    var posy = 0;
    if (!ev) ev = window.event;
    if (ev.pageX || ev.pageY) {
      posx = ev.pageX;
      posy = ev.pageY;
    } else if (ev.clientX || ev.clientY) {
      posx = ev.clientX + body.scrollLeft + document.body.scrollLeft;
      posy = ev.clientY + body.scrollTop + document.body.scrollTop;
    }
    return { x: posx, y: posy };
  };

  // mousePos: current mouse position
  // lastMousePos: last last recorded mouse position (at the time the last image was shown)
  var mousePos = { x: 0, y: 0 };
  var lastMousePos = { x: 0, y: 0

    // update the mouse position
  };window.addEventListener('mousemove', function (ev) {
    return mousePos = getMousePos(ev);
  });

  // gets the distance from the current mouse position to the last recorded mouse position
  var getMouseDistance = function getMouseDistance() {
    return MathUtils.distance(mousePos.x, mousePos.y, lastMousePos.x, lastMousePos.y);
  };

  var Image = function () {
    function Image(el) {
      (0, _classCallCheck3.default)(this, Image);

      this.DOM = { el: el
        // image deafult styles
      };this.defaultStyle = {
        x: 0,
        y: 0,
        opacity: 1
        // get sizes/position
      };this.getRect();
      // init/bind events
      this.initEvents();
    }

    (0, _createClass3.default)(Image, [{
      key: 'initEvents',
      value: function initEvents() {
        var _this = this;

        // on resize get updated sizes/position
        window.addEventListener('resize', function () {
          return _this.resize();
        });
      }
    }, {
      key: 'resize',
      value: function resize() {
        // reset styles
        TweenMax.set(this.DOM.el, this.defaultStyle);
        // get sizes/position
        this.getRect();
      }
    }, {
      key: 'getRect',
      value: function getRect() {
        this.rect = this.DOM.el.getBoundingClientRect();
      }
    }]);
    return Image;
  }();

  var ImageTrail = function () {
    function ImageTrail() {
      var _this2 = this;

      (0, _classCallCheck3.default)(this, ImageTrail);

      // images container
      this.DOM = { content: document.querySelector('.it-ImageTrail')
        // array of Image objs, one per image element
      };this.images = [];[].concat((0, _toConsumableArray3.default)(this.DOM.content.querySelectorAll('.it-ImageTrail_Image'))).forEach(function (img) {
        return _this2.images.push(new Image(img));
      });
      // total number of images
      this.imagesTotal = this.images.length;
      // upcoming image index
      this.imgPosition = 0;
      // zIndex value to apply to the upcoming image
      this.zIndexVal = 1;
      // mouse distance required to show the next image
      this.threshold = window.innerWidth / (this.images.length * 2);
      this.showNextImage();
      this.isActive = false;

      containerEl.addEventListener('mouseenter', function () {
        return _this2.isActive = true;
      });
      containerEl.addEventListener('mouseleave', function () {
        return _this2.isActive = false;
      });

      // render the images
      requestAnimationFrame(function () {
        return _this2.render();
      });
    }

    (0, _createClass3.default)(ImageTrail, [{
      key: 'render',
      value: function render() {
        var _this3 = this;

        if (this.isActive) {
          // get distance between the current mouse position and the position of the previous image
          var distance = getMouseDistance();

          // if the mouse moved more than [this.threshold] then show the next image
          if (distance > this.threshold) {
            this.showNextImage();
          }
        }

        // loop..
        requestAnimationFrame(function () {
          return _this3.render();
        });
      }
    }, {
      key: 'showNextImage',
      value: function showNextImage() {
        // show image at position [this.imgPosition]
        var img = this.images[this.imgPosition];
        // kill any tween on the image
        TweenMax.killTweensOf(img.DOM.el);

        new TimelineMax()
        // show the image
        .set(img.DOM.el, {
          opacity: 1,
          x: mousePos.x > lastMousePos.x ? 100 : -100,
          zIndex: this.zIndexVal
        }, 0)
        // animate position
        .to(img.DOM.el, 1.2, {
          ease: Expo.easeOut,
          x: 0
        }, 0);

        ++this.zIndexVal;
        this.imgPosition = this.imgPosition < this.imagesTotal - 1 ? this.imgPosition + 1 : 0;

        lastMousePos = mousePos;
      }
    }]);
    return ImageTrail;
  }();

  /***********************************/
  /********** Preload stuff **********/

  // Preload images


  var preloadImages = function preloadImages() {
    return new _promise2.default(function (resolve, reject) {
      (0, _imagesloaded2.default)(document.querySelectorAll('.it-ImageTrail_Image'), { background: true }, resolve);
    });
  };

  // And then..
  preloadImages().then(function () {
    containerEl = (0, _functional.getElement)('.js-MouseTrail');

    // Remove the loader
    document.body.classList.remove('loading');
    new ImageTrail();
  });
}